import React from "react";

// ICONS
import headerIcon from "../../../static/img/img-ihr-by-bodymatter-hr-logo-black-sm@3x.png";

// STYLES
import "./OfferExpired.scss";

const OfferExpired: React.FC = () => {
    return (
        <div className="OfferExpired">
            <div className="OfferExpired__content">
                <img
                    src={headerIcon}
                    loading="lazy"
                    alt="Instant Heart Rate"
                    className="OfferExpired__logo"
                />
                <h4 className="OfferExpired__title">Offer Expired</h4>
                <p className="OfferExpired__message">
                    This offer is no longer available.
                </p>

                <button
                    className="OfferExpired__button"
                    type="button"
                    onClick={() => {
                        const url = process.env.REACT_APP_UNIVERSAL_DEEP_LINK;
                        if (url) {
                            window.location.assign(url);
                        } else {
                            console.error(
                                "Missing REACT_APP_UNIVERSAL_DEEP_LINK",
                            );
                        }
                    }}
                >
                    Open Instant Heart Rate
                </button>
            </div>
        </div>
    );
};

export default OfferExpired;
